export const ease = [0.16, 1, 0.3, 1];

export const viewportOnce = { once: true, amount: 0.2 };

export const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease }
  }
};

export const staggerChildren = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.08 }
  }
};

// Pointer position → CSS custom properties consumed by `.card` spotlight styles.
export const trackSpotlight = (event) => {
  const rect = event.currentTarget.getBoundingClientRect();
  event.currentTarget.style.setProperty("--mx", `${event.clientX - rect.left}px`);
  event.currentTarget.style.setProperty("--my", `${event.clientY - rect.top}px`);
};
